"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const typography_1 = require("../styles/typography");
const ResponsiveContainer_1 = require("../components/ResponsiveContainer");
class ButtonComponent extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.state = {
            mouseDown: false,
        };
        this.setState = this.setState.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
    }
    componentDidMount() {
        this.ref.current.ontouchstart = this.handleTouchStart;
    }
    forceTouchEventBlur() {
        const contentEditableText = document.getElementById('contentEditableText');
        if (contentEditableText && contentEditableText.children[1] === document.activeElement) {
            const element = contentEditableText.children[1];
            element.blur();
        }
    }
    handleMouseUp() {
        const { type, onClick } = this.props;
        if (type === 'disabled') {
            return false;
        }
        this.setState({ mouseDown: false });
        onClick();
    }
    handleMouseDown() {
        this.setState({ mouseDown: true });
    }
    handleTouchStart(e) {
        const { type, onClick } = this.props;
        if (type === 'disabled') {
            return false;
        }
        this.setState({ mouseDown: true });
        this.forceTouchEventBlur();
        onClick();
        e.preventDefault();
    }
    handleTouchEnd() {
        this.setState({ mouseDown: false });
    }
    render() {
        const { text, size, type, overrideWidth, style, mouseDownColors } = this.props;
        const { mouseDown } = this.state;
        let outerStyle = {
            borderRadius: 5,
            textAlign: 'center',
            display: 'inline-block',
        };
        let innerStyle = Object.assign({}, typography_1.text, typography_1.semibold, { color: 'white' });
        switch (size) {
            case 'large':
                innerStyle = Object.assign({}, innerStyle, { padding: '16px 32px 16px 32px', fontSize: 16 });
                outerStyle = Object.assign({}, outerStyle, { height: 48 });
                break;
            case 'small':
                innerStyle = Object.assign({}, innerStyle, { padding: '8px 24px 8px 24px', fontSize: 14 });
                outerStyle = Object.assign({}, outerStyle, { height: 32 });
                break;
        }
        if (overrideWidth !== undefined) {
            innerStyle = Object.assign({}, innerStyle, { paddingLeft: 0, paddingRight: 0 });
            outerStyle = Object.assign({}, outerStyle, { width: overrideWidth });
        }
        let mouseStateColors = {};
        switch (type) {
            case 'primary':
                mouseStateColors = Object.assign({ active: colors_1.turquoise, inactive: colors_1.aquamarine }, mouseDownColors);
                outerStyle = Object.assign({}, outerStyle, { background: mouseDown === true ? mouseStateColors.inactive : mouseStateColors.active });
                break;
            case 'secondary':
                mouseStateColors = Object.assign({ active: colors_1.steel, inactive: colors_1.graphite }, mouseDownColors);
                outerStyle = Object.assign({}, outerStyle, { background: mouseDown === true ? mouseStateColors.inactive : mouseStateColors.active });
                break;
            case 'disabled':
                outerStyle = Object.assign({}, outerStyle, { background: colors_1.titanium });
                break;
            case 'regular':
                mouseStateColors = Object.assign({ active: colors_1.steel, inactive: colors_1.graphite }, mouseDownColors);
                innerStyle = Object.assign({}, innerStyle, { color: mouseDown === true ? mouseStateColors.inactive : mouseStateColors.active, fontSize: 17, padding: 0 });
                outerStyle = Object.assign({}, outerStyle, { height: 24, display: 'flex', alignItems: 'center' });
                break;
        }
        outerStyle = Object.assign({}, outerStyle, style.outerStyle);
        innerStyle = Object.assign({}, innerStyle, style.innerStyle);
        let ret;
        if (type !== 'disabled') {
            ret = (React.createElement("div", { style: outerStyle, onMouseDown: () => this.handleMouseDown(), onMouseUp: () => this.handleMouseUp(), ref: this.ref, onTouchEnd: e => this.handleTouchEnd() },
                React.createElement("div", { style: innerStyle }, text)));
        }
        else {
            ret = (React.createElement("div", { ref: this.ref, style: outerStyle },
                React.createElement("div", { style: innerStyle }, text)));
        }
        return ret;
    }
}
ButtonComponent.defaultProps = {
    text: '',
    type: 'primary',
    onClick: () => null,
    style: {
        innerStyle: {},
        outerStyle: {},
    },
    preventDefault: true,
};
const Button = (props) => {
    const ResponsiveButtonContainer = ResponsiveContainer_1.default(props)(ButtonComponent);
    return ResponsiveButtonContainer;
};
exports.default = Button;
